import api from 'libs/axios/api';
import { apiService } from 'libs/axios/services';
import { replaceParams } from 'utils/helpers';

const INTEGRATION_TYPE_TARGET = 8;
const INTEGRATION_TYPE_SOURCE = 7;

function mapDetailItemToManagementUnit(item: IIntegrationTaskDetailItem): IManagementUnit {
    const locationName =
        item.container?.location_name ??
        [item.major_location_name, item.middle_location_name, item.minor_location_name]
            .filter(Boolean)
            .join('-');
    const contentName =
        item.container?.content_name ??
        [item.major_content_name, item.middle_content_name, item.minor_content_name]
            .filter(Boolean)
            .join('-');
    const weightQty =
        item.content_unit != null ? `${item.amount} ${item.content_unit}` : String(item.amount);

    return {
        id: item.container_id,
        management_unit_id: item.container_id,
        content_type_name: contentName || item.container_category_name || '',
        weight_quantity: weightQty,
        storage_company_name: item.company_name || '',
        storage_location_name: locationName || '',
        remark: item.comment ?? '',
        image1: item.image1 ?? undefined,
        image2: item.image2 ?? undefined,
        image3: item.image3 ?? undefined,
        image4: item.image4 ?? undefined,
        image5: item.image5 ?? undefined,
        create_at: item.create_at,
        update_at: item.update_at,
    };
}

export const getUnitIntegrationTaskListFetcher = async (
    request: UnitIntegrationTaskListRequest,
): Promise<ApiResponse<ResponseBase<IUnitIntegrationTask[]>>> => {
    return apiService.get<UnitIntegrationTaskListRequest, ResponseBase<IUnitIntegrationTask[]>>(
        api.unitIntegrationTaskList,
        request,
        undefined,
        true,
    );
};

export const getUnitIntegrationTaskDetailFetcher = async (
    taskId: string,
): Promise<ApiResponse<IUnitIntegrationDetailState>> => {
    const res = await apiService.get<unknown, ResponseBase<IIntegrationTaskDetailItem[]>>(
        replaceParams(api.unitIntegrationTaskDetail, { task_id: taskId }),
        undefined,
        undefined,
        true,
    );

    if (!res.success) {
        return {
            success: false,
            error: 'error' in res ? res.error : 'Unknown error',
        };
    }

    const rawData = res.data?.data;
    if (!Array.isArray(rawData)) {
        return {
            success: false,
            error: 'Invalid response data',
        };
    }

    const items = rawData as IIntegrationTaskDetailItem[];
    const destinationItem = items.find((i) => i.type === INTEGRATION_TYPE_TARGET);
    const targetUnit = destinationItem ? mapDetailItemToManagementUnit(destinationItem) : null;
    const sourceUnits = items
        .filter((i) => i.type === INTEGRATION_TYPE_SOURCE)
        .map(mapDetailItemToManagementUnit);

    return {
        success: true,
        message: (res.data as ResponseBase<IIntegrationTaskDetailItem[]>)?.message ?? '',
        data: {
            task_id: taskId,
            targetUnit,
            sourceUnits,
        },
    };
};
